export default __webpack_public_path__ + "static/media/09.558f4cc8.svg";